var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.extraClass.concat( [( _obj = {}, _obj[_vm.preset] = !!_vm.preset, _obj.iconAtEnd = _vm.iconAtEnd, _obj.center = _vm.center, _obj )]),style:({
    borderRadius: _vm.borderRadius + 'px',
    backgroundColor: _vm.hovering ? _vm.hoverColor : _vm.color,
    color: _vm.textColor,
    height: _vm.height ? _vm.height + 'px' : 'auto',
    width: _vm.width ? _vm.width : 'auto',
    minWidth: _vm.minWidth ? _vm.minWidth : 'auto',
    fontSize: _vm.fontSize
  }),attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')},"mouseover":_vm.mouseOver,"mouseout":_vm.mouseOut}},[(!_vm.preset)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.preset == 'facebook')?_c('i',{staticClass:"fab fa-facebook-f"}):_vm._e(),(_vm.preset == 'whatsapp')?_c('i',{staticClass:"fab fa-whatsapp"}):_vm._e(),(_vm.preset == 'twitter')?_c('i',{staticClass:"fab fa-twitter"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }